var selectors = document.querySelectorAll(".accessory_selector");
// console.log("selectors")
selectors.forEach((item, index)=>{
  accessory = item.querySelector('select');
  // console.log(accessory)
  accessory.addEventListener('change', function(e) {
    option = e.target.value
    // console.log(index)
    if(option){
      document.querySelector(`input[name="items[${index+1}][id]"]`).disabled = false;
      document.querySelector(`input[name="items[${index+1}][quantity]"]`).disabled = false;
      document.querySelector(`input[name="items[${index+1}][quantity]"]`).value = option;
    }else{
      document.querySelector(`input[name="items[${index+1}][id]"]`).disabled = true;
    }
  });
})
